import React from 'react';
import PropTypes from 'prop-types';
import { HelpButton } from '@bingads-webui-react/help-popup';
import { Label } from '@fluentui/react-components';

export const LabelHelpButton = ({
  i18n,
  className,
  labelTitle,
  helpId,
  helpIAriaLabel,
}) => {
  const mappedArialLabel = helpIAriaLabel || i18n.getString(_TL_('Learn more about {{term}}'), { term: labelTitle });
  return (
    <Label className={className}>
      {labelTitle}
      <HelpButton aria-label={mappedArialLabel} topic={helpId} />
    </Label>
  );
};

LabelHelpButton.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  className: PropTypes.string.isRequired,
  labelTitle: PropTypes.string.isRequired,
  helpId: PropTypes.string.isRequired,
  helpIAriaLabel: PropTypes.string,
};
LabelHelpButton.defaultProps = {
  helpIAriaLabel: null,
};
